import startMockServer from './server';

const primaryBackgroundColor = '#003354';
const successBackgroundColor = '#006400';
const abortBackgroundColor = '#B22222';
const warningBackgroundColor = '#FFA07A';

const template = `
background: [BackgroundColor];
color: [Color];
font-size: [FontSize];
border-radius: 2px;
padding: 3px 0;
`;

const darkStyle = template.replace('[Color]', '#ffffff').replace('FontSize', '14px');
const lightStyle = template.replace('[Color]', '#000000').replace('FontSize', '10px');

const primaryConsoleStyle = darkStyle.replace('[BackgroundColor]', primaryBackgroundColor);
const successConsoleStyle = darkStyle.replace('[BackgroundColor]', successBackgroundColor);
const abortConsoleStyle = darkStyle.replace('[BackgroundColor]', abortBackgroundColor);
const warningConsoleStyle = lightStyle.replace('[BackgroundColor]', warningBackgroundColor);

let server = null;

const startService = () => {
  const mockLogOn = JSON.parse(sessionStorage.getItem('mockLogOn'));

  console.log('%c Started Mock Service ', successConsoleStyle);
  console.log(mockLogOn ?
    '%c Mock Logging enabled. press SHIFT + F2 to toggle logging; endpoints not mocked will log out below as a "Mirage: Passthrough request" ' :
    '%c Mock Logging disabled. press SHIFT + F2 to toggle logging ',
  warningConsoleStyle);

  sessionStorage.setItem('mockModeOn', true);

  server = startMockServer();

  server.logging = JSON.parse(sessionStorage.getItem('mockLogOn'));
};

const stopService = () => {
  console.log('%c Stopped Mock Service ', abortConsoleStyle);

  sessionStorage.setItem('mockModeOn', false);

  server.shutdown();
};

const toggleLogging = () => {
  const mockLogOn = !JSON.parse(sessionStorage.getItem('mockLogOn'));

  console.log(mockLogOn ?
    '%c Mock Logging enabled. press SHIFT + F2 to toggle logging; endpoints not mocked will log out below as a "Mirage: Passthrough request" ' :
    '%c Mock Logging disabled. press SHIFT + F2 to toggle logging ',
  warningConsoleStyle);

  sessionStorage.setItem('mockLogOn', mockLogOn);

  server.logging = mockLogOn;
};

export default function setupMockservice() {
  console.log('%c Offline Mock Service available. press F2 to toggle service on/off ', primaryConsoleStyle);

  let keyPressed = {};
  let mockModeOn = JSON.parse(sessionStorage.getItem('mockModeOn'));

  if (mockModeOn) {
    startService();
  }

  window.addEventListener('keydown', function (e) {
    keyPressed[e.key + e.location] = true;

    if (keyPressed.Shift1 === true && keyPressed.F20 === true) {
      toggleLogging();
      return;
    }

    if (keyPressed.F20 === true) {
      if (mockModeOn) {
        stopService();
      }

      if (!mockModeOn) {
        startService();
      }

      mockModeOn = !mockModeOn;
      keyPressed = {}; // reset key map
      return;
    }

  }, false);

  window.addEventListener('keyup', function (e) {
    keyPressed[e.key + e.location] = false;

    keyPressed = {};
  }, false);
}
